import { render, staticRenderFns } from "./ErrorAppVersionModal.vue?vue&type=template&id=716f2012&"
import script from "./ErrorAppVersionModal.vue?vue&type=script&lang=js&"
export * from "./ErrorAppVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAppVersionModal.vue?vue&type=style&index=0&id=716f2012&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716f2012')) {
      api.createRecord('716f2012', component.options)
    } else {
      api.reload('716f2012', component.options)
    }
    module.hot.accept("./ErrorAppVersionModal.vue?vue&type=template&id=716f2012&", function () {
      api.rerender('716f2012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/ErrorAppVersionModal.vue"
export default component.exports